module.exports = __webpack_public_path__ + "0107fac82980bad21aafc468ed4a2b10.pdf";